<template>
    <span v-if="prop_value!=undefined && prop_value_total!=undefined">
        <v-simple-table dense>
            <template v-slot:default>
                <tbody>
                    <tr>
                        <td class="text-left">
                            {{prop_value}}%
                        </td>
                        <td class="text-right">
                            <span v-if="data_color_code==0">
                                <v-icon color="red" medium>mdi-circle</v-icon>
                            </span>
                            <span v-else-if="data_color_code==1">
                                <v-icon color="yellow" medium>mdi-circle</v-icon>
                            </span>
                            <span v-else-if="data_color_code==2">
                                <v-icon color="green" medium>mdi-circle</v-icon>
                            </span>
                            <span v-else>
                                <v-icon color="blue" medium>mdi-circle</v-icon>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </span>
    <span v-else>
        <v-icon color="black" medium>mdi-circle</v-icon>
    </span>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentColorCoderPercentage',

    props:[
        'prop_value',
        'prop_value_total'
    ],

    data: function()
    {
        return {
        }
    },

    computed:{
        data_color_code:function()
        {
            if(this.prop_value <= 40)
            {
                return 0
            }
            else if((this.prop_value >=41) && (this.prop_value <=60))
            {
                return 1
            }
            else if((this.prop_value >=61) && (this.prop_value <=100))
            {
                return 2
            }
            else
            {
                return 0
            }
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
